import { SelectionCalculator } from '@sravni/creditselection-react/lib/SelectionCalculator';
import { Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import getConfig from 'next/config';

import { Card1, Card2, Card3 } from 'shared/assets';
import { isProduction, useAppSelector } from 'shared/lib';
import { AppContainer } from 'shared/ui/AppContainer';
import { FeatureCard } from 'shared/ui/FeatureCard';
import { NoSSR } from 'shared/ui/NoSSR';

import { SeoBreadcrumbs, seoH1Selector, SeoPrefooter, seoSubHeadingSelector } from 'entities/metadata';
import { isLoggedSelector, useGetIfUserHasEsiaQuery } from 'entities/user';

import { RatesChart } from 'widgets/RatesChart';
import { SeoBlocks } from 'widgets/SeoBlocks';

import styles from './RatesPage.module.scss';

export const RatesPage = () => {
  const isMobile = useIsMobile();
  const headingText = useAppSelector(seoH1Selector);
  const subHeadingText = useAppSelector(seoSubHeadingSelector);
  const isLoggedIn = useAppSelector(isLoggedSelector);
  const { data: isUserHasEsia } = useGetIfUserHasEsiaQuery();
  const { publicRuntimeConfig } = getConfig();

  return (
    <AppContainer
      hidePaddings
      className={styles.page}
    >
      <Space
        direction="vertical"
        size={32}
      >
        <Space
          className={cn('h-pt-24 h-pb-24', { 'h-pl-16 h-pr-16': isMobile })}
          direction="vertical"
          size={8}
        >
          <Heading level={1}>{headingText}</Heading>
          <Text
            className="h-color-D60"
            data-qa="SeoMiniText"
          >
            {subHeadingText}
          </Text>
        </Space>

        <RatesChart />

        <NoSSR>
          <SelectionCalculator
            isLoggedIn={isLoggedIn}
            isLoggedInEsia={!!isUserHasEsia}
            baseUrl={publicRuntimeConfig.headerDomains.base}
            enableAnalytics={isProduction() ? true : 'logs'}
            eventLabelPage="Страница ставок"
            defaultFormValues={{
              amount: 500_000,
            }}
            formParams={{
              amount: {
                min: 1_000,
                max: 15_000_000,
                step: 50_000,
              },
            }}
          />
        </NoSSR>

        <Space
          size={isMobile ? 8 : 24}
          direction={isMobile ? 'vertical' : 'horizontal'}
        >
          <FeatureCard
            image={Card1 as string}
            title="Как формируется график?"
            subtitle="График формируется на основе статистики выданных кредитов по пользователям сервиса Кредитный рейтинг на Сравни"
          />
          <FeatureCard
            image={Card2 as string}
            title="Почему в&nbsp;рекламе банков ставки ниже?"
            subtitle="В расчёте показываем полную стоимость кредита (ПСК), а&nbsp;не&nbsp;ставки “от” из&nbsp;рекламы. ПСК включает тело долга, переплату и&nbsp;сервисные услуги банка. Это даёт более реалистичную картину о&nbsp;фактической стоимости кредита"
          />
          <FeatureCard
            image={Card3 as string}
            title="Я получу кредит под такой процент в&nbsp;банке?"
            subtitle="Условия кредитования банк определяет индивидуально. Авторизуйтесь через Госуслуги - и&nbsp;мы покажем ваш кредитный рейтинг и&nbsp;финансовый потенциал, какую сумму смогут одобрить банки"
          />
        </Space>

        <SeoBlocks />
        <SeoPrefooter />
        <SeoBreadcrumbs />
      </Space>
    </AppContainer>
  );
};
